import React, { useState } from 'react';
import LoadingScreen from '../../components/muiLegacy/LoadingScreen/LoadingScreen';
import VoxelPageContainer from '../../components/voxel/Containers/VoxelPageContainer';
import { usersApiService } from '../../graphql/users/usersApiService';
import useIsScrolling from '../../logic/otherUtilities/useIsScrolling';
import StartPageAppBar from '../StartPage/components/StartPageAppBar';
import ButtonsBoard from './ButtonsBoard/ButtonsBoard';
import ColorsBoard from './ColorsBoard';
import ComponentsBoard from './ComponentsBoard';
import TypographyBoard from './TypographyBoard';
import StatusBoard from './StatusBoard';
import NavsBoard from './NavsBoard';
import FormsBoard from './FormsBoard/FormsBoard';
import TablesBoard from './TablesBoard';
import VoxelToggleTabs from '../../components/voxel/Tabs/VoxelToggleTabs';
import { MenuItem } from '../../components/voxel/Menu/VoxelMenu';

export interface StorybookProps { }

export type Dashboards = 'forms' | 'tables' | 'buttons' | 'navs' | 'status' | 'components' | 'typography' | 'colors';

const menuItems: MenuItem[] = [
  { id: 'forms', name: 'Forms' },
  { id: 'tables', name: 'Tables' },
  { id: 'buttons', name: 'Buttons' },
  { id: 'navs', name: 'Navs' },
  { id: 'status', name: 'Status' },
  { id: 'components', name: 'Components' },
  { id: 'typography', name: 'Typography' },
  { id: 'colors', name: 'Colors' },
];

export const Storybook: React.FC<StorybookProps> = ({ }) => {


  const [selectedId, setSelectedId] = useState<Dashboards>('forms');

  // Get user
  const {
    user,
    team,
    query: userQuery,
    availableUsers,
  } = usersApiService.queries.useGetCurrentUser();

  const isScrolling = useIsScrolling();

  if (!user) {
    return <LoadingScreen />;
  }

  return (
    <>
      <StartPageAppBar
        team={team}
        user={user}
        isScrolling={isScrolling}
        availableUsers={availableUsers}
      />
      <VoxelPageContainer className="flex flex-col gap-8" paddingTopClass='pt-0'>
        <VoxelToggleTabs
          menuListItems={menuItems}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
        />
        {selectedId === 'forms' && <FormsBoard />}
        {selectedId === 'tables' && <TablesBoard />}
        {selectedId === 'buttons' && <ButtonsBoard />}
        {selectedId === 'navs' && <NavsBoard />}
        {selectedId === 'components' && <ComponentsBoard />}
        {selectedId === 'typography' && <TypographyBoard />}
        {selectedId === 'colors' && <ColorsBoard />}
        {selectedId === 'status' && <StatusBoard />}
      </VoxelPageContainer>
    </>
  );
};

export default Storybook;
